import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import VideoPlayerComponent from '../video/videoPlayerComponent';
import './templates.css';
import SimplePlaylist from '../playlists/simplePlaylist';
// import CarrouselHorizontal from '../playlists/carrouselHorizontal';
const CarrouselHorizontal = React.lazy(() => import('../playlists/carrouselHorizontal'));

export default function PlaylistVerticalTemplate({ config, videoPlayer, playlistmodel }) {
  return (
    <div className="tpx-vertical-tmp">
      <VideoPlayerComponent config={config} videoPlayer={videoPlayer} />
      <SimplePlaylist playlistmodel={playlistmodel} videoPlayer={videoPlayer}></SimplePlaylist>
      <Suspense fallback={<div>Loading...</div>}>
        <CarrouselHorizontal
          playlistmodel={playlistmodel}
          config={config}
          videoPlayer={videoPlayer}
        />
      </Suspense>
    </div>
  );
}

PlaylistVerticalTemplate.propTypes = {
  config: PropTypes.object.isRequired,
  videoPlayer: PropTypes.object.isRequired,
  playlistmodel: PropTypes.object.isRequired,
};
